import React from 'react';
import Styles from './shortcut.module.css';

export default function Shortcut({ style, label, ...props }) {
  return (
    <div className={Styles.shortcut} {...props}>
      <div className={Styles.shortcutIcon} style={{ ...style }}></div>
      <div className={Styles.shortcutText}>{label}</div>
    </div>
  );
}
